import Eye from '@mui/icons-material/VisibilityOutlined';

import IconInvoice from '@/assets/common/iconInvoice';
import IconPunto99 from '@/assets/common/iconPunto99';
import ShipmentsIcon from '@/assets/sidebar/shipments';
import Button from '@/components/Button';

import SendTypes from './dependencies/SendTypes';

export const cardContent = [
  {
    id: 1,
    icon: ShipmentsIcon,
    title: 'Envíos',
    filter: 'envios',
  },
  {
    id: 2,
    icon: Eye,
    title: 'Seguimiento y monitoreo',
    filter: 'monitoreo',
  },
  {
    id: 3,
    icon: IconPunto99,
    title: 'punto99',
    filter: 'punto99',
  },
  {
    id: 4,
    icon: IconInvoice,
    title: 'Facturación',
    filter: 'facturacion',
  },
];

export const FAQS = (navigate: (path: string) => void) => [
  {
    id: 1,
    category: 'envios',
    faqTitle: '¿Qué tipo de envíos puedo hacer?',
    htmlContent: <SendTypes />,
  },
  {
    id: 2,
    category: 'envios',
    faqTitle: '¿Cuál es la cobertura?',
    htmlContent: (
      <>
        <p className="my-4">Verifica si tu envío llega a tu destino.</p>
        <Button onClick={() => navigate('/coverage')}>Ir al cotizador</Button>
      </>
    ),
  },
  {
    id: 3,
    category: 'envios',
    faqTitle:
      '¿Cómo puedo hacer el cambio de dirección o datos una vez que la orden ya está creada?',
    htmlContent: (
      <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
        <li>
          Entra a{' '}
          <a href="https://tracking.99minutos.com/" target="_blank" style={{ color: '#85C440' }}>
            Rastrear paquete
          </a>
        </li>
        <li>Ingresa el código de rastreo.</li>
        <li>
          Una vez ingresada la información, te aparecerá una opción que dice “Reprogramar tu
          entrega”. Haz clic en esa opción y te llegará un correo.
        </li>
        <li>En el correo podrás cambiar la fecha de entrega, dirección y datos de contacto.</li>
      </ul>
    ),
  },
  {
    id: 4,
    category: 'envios',
    faqTitle: '¿Por qué debo escoger 99minutos para hacer mis envíos?',
    htmlContent: (
      <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
        <li>99minutos es la empresa de logística con gran cobertura y poco tiempo de entrega.</li>
        <li>
          Nos encargamos de toda la logística para llevar tu producto hasta las manos de tu cliente
          en México, Chile, Colombia y Perú.
        </li>
        <li>
          Nuestra tarifa no solo es la mejor del mercado; es fija; no pagas por volumen, ni tiempo
          de viaje.
        </li>
        <li>
          Primera compañía en América en lograr más del 25% de sus entregas con cero emisiones.
        </li>
        <li>Rastreo en tiempo real de tu envío.</li>
        <li>Facilidad de cobro a contra entrega.</li>
        <li>Servicio y atención personalizada.</li>
      </ul>
    ),
  },
  {
    id: 5,
    category: 'facturacion',
    faqTitle: '¿Cómo puedo facturar?',
    htmlContent: (
      <>
        <div style={{ marginBottom: '24px' }}>
          <strong style={{ display: 'block', marginBottom: '12px' }}>
            Para clientes en México
          </strong>
          <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
            <li>Ingresar tu RFC y datos fiscales dando clic en Editar mi perfil.</li>
            <li>
              Las facturas se generan automáticamente y puedes verlas en el apartado Mis Facturas en
              el menú del lado izquierdo.
            </li>
            <li>
              Para cualquier duda relacionada favor de enviar un correo a{' '}
              <a href="mailto:soporte.finanzas@99minutos.com" style={{ color: '#85C440' }}>
                soporte.finanzas@99minutos.com
              </a>
            </li>
          </ul>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <strong style={{ display: 'block', marginBottom: '12px' }}>Para clientes en Perú</strong>
          <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
            <li>
              Enviar los siguientes datos al correo{' '}
              <a href="mailto:jenny.arellano@99minutos.com" style={{ color: '#85C440' }}>
                jenny.arellano@99minutos.com
              </a>{' '}
              con copia a: liz.valladolid@99minutos.com
              <ul
                style={{
                  listStyleType: 'circle',
                  listStylePosition: 'outside',
                  paddingLeft: '20px',
                  marginTop: '8px',
                }}
              >
                <li>RUC</li>
                <li>Razón social</li>
              </ul>
            </li>
          </ul>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <strong style={{ display: 'block', marginBottom: '12px' }}>
            Para clientes en Colombia
          </strong>
          <p style={{ marginBottom: '8px' }}>
            Enviar los siguientes datos al correo marcela.fandino@99minutos.com
          </p>
          <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
            <li>
              <strong>Personas jurídicas</strong>
              <ul
                style={{
                  listStyleType: 'circle',
                  listStylePosition: 'outside',
                  paddingLeft: '20px',
                  marginTop: '8px',
                }}
              >
                <li>Formato de inscripción y actualización de clientes FC-CL-001.</li>
                <li>Formato de autorización de tratamiento de datos FC-PR-003.</li>
                <li>Formato de declaración de origen de fondos FC-PR-002</li>
                <li>Copia de RUT actualizado.</li>
                <li>Copia cédula del representante legal.</li>
                <li>Certificado Cámara y Comercio.</li>
                <li>
                  Certificación Cuenta Bancaria (en caso de requerir servicio contra entrega).
                </li>
                <li>Certificado Composición Accionaria.</li>
                <li>Correo envío Factura Electrónica</li>
              </ul>
            </li>
            <li>
              <strong>Personas naturales</strong>
              <ul
                style={{
                  listStyleType: 'circle',
                  listStylePosition: 'outside',
                  paddingLeft: '20px',
                  marginTop: '8px',
                }}
              >
                <li>Formato de inscripción y actualización de clientes FC-CL-001.</li>
                <li>Formato de autorización de tratamiento de datos FC-PR-003.</li>
                <li>Formato de declaración de origen de fondos FC-PR-002.</li>
                <li>Copia de RUT actualizado (Si aplica).</li>
                <li>Copia cédula del representante.</li>
                <li>
                  Certificación Cuenta Bancaria (en caso de requerir servicio contra entrega).
                </li>
                <li>Correo envío Factura Electrónica</li>
              </ul>
            </li>
          </ul>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <strong style={{ display: 'block', marginBottom: '12px' }}>Para clientes en Chile</strong>
          <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
            <li>
              Se enviará la factura correspondiente la última semana del mes en caso de hacer una
              recarga por medio de Mercado Pago.
            </li>
            <li>
              Para clientes que generen las guías por medio de carga masiva se les hará llegar una
              prefactura para solicitar la orden de compra correspondiente o facturar directamente.
            </li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: 6,
    category: 'monitoreo',
    faqTitle: '¿Cómo puedo rastrear mi número de guía o paquete?',
    htmlContent: (
      <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
        <li>
          Entra a{' '}
          <a href="https://tracking.99minutos.com/" target="_blank" style={{ color: '#85C440' }}>
            Rastrear paquete
          </a>
        </li>
        <li>Ingresa el código de rastreo.</li>
        <li>
          Una vez ingresada la información, te aparecerá si tu paquete ya fue recolectado, se
          encuentra en tránsito, va en camino o ya fue entregado.
        </li>
      </ul>
    ),
  },
  {
    id: 7,
    category: 'monitoreo',
    faqTitle: '¿Por qué mi paquete lleva demasiado tiempo en estatus “Creado”?',
    htmlContent: (
      <div>
        <p className="my-4">
          Si tu paquete aún no ha sido recolectado esto puede deberse al origen del mismo:
        </p>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>
            Tienda departamental o e-commerce: Es muy probable que el establecimiento del cual sale
            tu producto está preparándolo aún, por lo que no tienes de qué preocuparte, una vez que
            esté en nuestras estaciones lo recibirás de acuerdo con el tipo de envío con el que está
            programado.
          </li>
          <li>
            {' '}
            Persona física: Si tu paquete es enviado por un tercero, haremos dos intentos para
            recolectar el producto, para agilizar que tu paquete llegue lo más rápido a nuestras
            estaciones, hemos creado punto99 ¡Te invitamos a conocerlo!
          </li>
        </ul>
      </div>
    ),
  },

  {
    id: 8,
    category: 'costos',
    faqTitle: '¿Cuáles son las tarifas y modalidades de envío con las que cuentan?',
    htmlContent: <Button onClick={() => navigate('/rates')}>Verificar Tarifas</Button>,
  },
  {
    id: 9,
    category: 'punto99',
    faqTitle: '¿Qué es punto99?',
    htmlContent: (
      <>
        <p>
          Un punto99 es un local comercial que funciona como lugar de entrega y recolección de
          paquetes para los clientes de 99minutos. Dejas tu paquete en el punto99 y después es
          recolectado por un Veloz para ser llevado a su destino final. Con esto buscamos robustecer
          la red logística y mejorar la experiencia de nuestros clientes.
        </p>
      </>
    ),
  },
  {
    id: 10,
    category: 'punto99',
    faqTitle: '¿Cómo funcionan los punto99?',
    htmlContent: (
      <>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>
            Se encargan de recibir tus paquetes y realizan la entrega a un veloz para gestionar la
            entrega al destino solicitado.
          </li>
          <li>Crea una orden y lleva tu paquete al punto99.</li>
          <li>
            El operador lo escaneará y entregará a un Veloz, quién se encargará de entregarlo a tu
            cliente.
          </li>
          <li>
            Una vez que tu cliente haya recibido el paquete, te enviaremos un correo de
            confirmación.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 11,
    category: 'punto99',
    faqTitle: '¿Cómo crear una orden para un punto99?',
    htmlContent: (
      <>
        <p className="my-4">
          Al crear una nueva orden, deberás llenar la dirección de origen, es decir, la dirección en
          la que debemos de recolectar el paquete. En la esquina izquierda del mapa podrás ver la
          cantidad de puntos99 que se encuentran disponibles a 1.5km de la dirección de origen. Si
          no encuentras esta opción es porque todavía no hay alguno cercano.
        </p>
        <p>
          punto99 se distingue en el mapa con marcadores verdes. Al seleccionar estos marcadores
          podrás ver la distancia a la que se encuentran y su horario de atención. En caso de que
          quieras dejar tu paquete en algún punto99, simplemente deberás seleccionar “Entregar en
          este punto”. Automáticamente verás el nombre y la ubicación del punto99 seleccionado y
          deberás llevar tu paquete a dicha dirección. Nosotros nos encargaremos de recogerlo y
          enviarlo a tu cliente.
        </p>
      </>
    ),
  },
  {
    id: 12,
    category: 'punto99',
    faqTitle: '¿Qué tipo de órdenes puedo crear en punto99?',
    htmlContent: (
      <>
        <p className="my-4">Tipo de entrega</p>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>SameDay</li>
          <li>Sprint</li>
          <li>CO2 Free</li>
          <li>Logística inversa - Retorno</li>
        </ul>
        <p className="my-4">Tamaños</p>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>Extra pequeño (Menos de 1kg)</li>
          <li>Pequeño (1kg a 2kg)</li>
          <li>Mediano (2kg a 3kg)</li>
        </ul>
      </>
    ),
  },
  {
    id: 13,
    category: 'punto99',
    faqTitle: '¿Cuáles son los beneficios de usar punto99? ',
    htmlContent: (
      <>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>Puedes dejar tu paquete en cualquier punto99.</li>
          <li>Agilizar los procesos de recolección y entrega de tus paquetes.</li>
          <li>Ofrecer un servicio más flexible y accesible para tus clientes.</li>
          <li>Contribuir a la recuperación económica de los puntos99.</li>
          <li>Optimización de rutas y tiempos de entrega.</li>
        </ul>
      </>
    ),
  },
  {
    id: 14,
    category: 'punto99',
    faqTitle: '¿Cómo reconoceré los locales comerciales que reciben mis paquetes?',
    htmlContent: (
      <>
        <p>
          Los negocios afiliados como punto99 deben tener un banderin y stickers con nuestro logo
          para su distinción. También puedes consultar en nuestra network de puntos afiliados{' '}
          <a
            href="https://network.punto99.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#85C440' }}
          >
            https://network.punto99.com/
          </a>
        </p>
      </>
    ),
  },
  {
    id: 15,
    category: 'punto99',
    faqTitle: '¿Cómo puedo saber en dónde se encuentra mi orden de un punto99?',
    htmlContent: (
      <>
        <p className="my-4">
          Buscamos que sepas el estatus de tu orden en cada paso del proceso, para eso te haremos
          llegar los siguientes correos electrónicos:
        </p>
        <ul style={{ listStyleType: 'number', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>
            Punto99 listo para la recolección: se te enviará cuando el punto99 que seleccionaste al
            crear tu orden esté listo para recolectar tu paquete.
          </li>
          <li>
            El paquete se encuentra en el punto99: Se te enviará cuando hayas depositado
            exitosamente tu paquete en un punto99 y esté en espera de ser recolectado por un Veloz.
          </li>
          <li>
            Paquete se encuentra en camino: se te enviará cuando tu paquete ya ha sido recolectado
            en el punto99 por un Veloz, y se encuentra en camino a su destino final.
          </li>
          <li>
            Tu cliente ya puede recoger paquete: se te enviará cuando tu paquete ya haya llegado a
            un punto99 y está listo para ser recogido por tu cliente.
          </li>
          <li>
            Entrega de paquete al cliente final:
            <ul
              style={{
                listStyleType: 'circle',
                listStylePosition: 'outside',
                paddingLeft: '20px',
                marginTop: '8px',
              }}
            >
              <li>
                Exitosa - Se te enviará un correo avisándote que el proceso se completó exitosamente
                y que tu cliente ya tiene el paquete.
              </li>
              <li>
                No exitosa - Se te enviará un correo avisándote que el proceso no pudo completarse
                ya que el paquete fue rechazado o no fue recolectado por tu cliente.
              </li>
            </ul>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 16,
    category: 'punto99',
    faqTitle: '¿Cómo cancelar mi orden en un punto99?',
    htmlContent: (
      <>
        <p className="my-4">
          Para cancelar y recoger una orden que se encuentra en un punto99 debes seguir este paso a
          paso:
        </p>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>Ingresa a la plataforma y cancela la orden en Pedidos en Curso</li>
          <li>
            Una vez cancelada la orden te enviaremos un SMS/ E-mail con la confirmación y código de
            verificación para recoger tu orden. En el correo encontrarás: nombre, dirección y
            horarios del punto99
          </li>
          <li>
            En el punto99 debes indicarle al operador del punto99 el código de verificación para
            poder autenticar la devolución.
          </li>
          <li>El punto99 te entrega tu orden.</li>
        </ul>
      </>
    ),
  },
  {
    id: 17,
    category: 'punto99',
    faqTitle: '¿Cómo revisar los horarios al generar una guía?',
    htmlContent: (
      <>
        <p>
          Debes hacer clic en el icono donde está ubicado el P99 en el mapa y ahí se desplegará
          información adicional sobre el P99, incluyendo sus horarios.
        </p>
        <p>
          Consultar todos los puntos y sus horarios en:{' '}
          <a
            href="https://network.punto99.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#85C440' }}
          >
            https://network.punto99.com/
          </a>
        </p>
      </>
    ),
  },
  {
    id: 18,
    category: 'punto99',
    faqTitle: '¿Cuál es el horario límite de recolecta cuando el paquete se deja en P99?',
    htmlContent: (
      <>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>Sprint: Llévalo antes de las 16:00 hrs.</li>
          <li>SameDay: Llévalo antes de las 14:00 hrs.</li>
        </ul>
      </>
    ),
  },
  {
    id: 19,
    category: 'punto99',
    faqTitle: '¿Dónde puedo encontrar un punto99?',
    htmlContent: (
      <>
        <p>
          Puedes encontrar un mapa interactivo con la información de nuestros puntos afiliados en:{' '}
          <a
            href="https://network.punto99.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#85C440' }}
          >
            https://network.punto99.com/
          </a>
        </p>
      </>
    ),
  },
  {
    id: 20,
    category: 'punto99',
    faqTitle: '¿Dónde puedo consultar los horarios de apertura de los puntos99?',
    htmlContent: (
      <>
        <p>
          Puedes encontrar un mapa interactivo con la información de nuestros puntos afiliados en:{' '}
          <a
            href="https://network.punto99.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#85C440' }}
          >
            https://network.punto99.com/
          </a>
        </p>
      </>
    ),
  },
  {
    id: 21,
    category: 'punto99',
    faqTitle: '¿Por qué se canceló mi guía en un P99?',
    htmlContent: (
      <>
        <p>
          Las guías no deben cancelarse a menos que el cliente así lo pida, en caso de notar que tu
          guía fue cancelada por favor notifícanos para corregirlo. Envía un correo a{' '}
          <a href="mailto:info@punto99.mex" style={{ color: '#85C440' }}>
            info@punto99.mex
          </a>
        </p>
      </>
    ),
  },
  {
    id: 22,
    category: 'punto99',
    faqTitle: '¿Por qué me manda a un P99 en vez de que vengan a mi domicilio?',
    htmlContent: (
      <>
        <p>
          Para facilitar la recolección a clientes que no se encuentran todo el tiempo en su
          domicilio
        </p>
      </>
    ),
  },
  {
    id: 23,
    category: 'punto99',
    faqTitle: '¿Cómo comprobar si la recepción de mi paquete fue correcta?',
    htmlContent: (
      <>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>
            El operador del P99 te puede mostrar la confirmación de recepción desde su APP de
            punto99
          </li>
          <li>
            Puedes también confirmar esa recepción en el tracking de tu orden, en historial de tu
            orden o en pedidos en curso
          </li>
          <li>También te enviamos un correo confirmando la recepción de tu paquete</li>
        </ul>
      </>
    ),
  },
  {
    id: 24,
    category: 'punto99',
    faqTitle: '¿Cómo puedo ser un punto99?',
    htmlContent: (
      <>
        <p className="my-4">
          ¿Tienes un local comercial y quieres generar ingresos extras? Con 99 minutos es posible.
          Solo necesitas:
        </p>
        <ul style={{ listStyleType: 'disc', listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li>Un espacio de al menos 3 m² libre para almacenamiento</li>
          <li>Estar inscrito ante el SAT como Persona física o Moral y emitir facturas con CFDI</li>
          <li>Contar con conexión a internet</li>
        </ul>
        <p className="my-4">
          Registra tu local aquí:{' '}
          <a
            href="https://www.punto99.mx/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#85C440' }}
          >
            https://www.punto99.mx/
          </a>{' '}
          y un afiliador se pondrá en contacto para el seguimiento.
        </p>
      </>
    ),
  },
];
